import React from 'react';
import TextInputField from './TextInputField';
import { translate } from 'translations/i18n';

const CompanyName = () => {
  return (
    <TextInputField
      name="companyName"
      type="text"
      placeholder={translate('common.companyName')}
      showClearIcon
    />
  );
};

export default CompanyName;
